var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HorizontalMenu',{attrs:{"hideLines":true,"items":_vm.items,"size":"small"},on:{"onChange":function($event){return _vm.$emit('onChange', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }